import styled from 'styled-components';
import { GatsbyImage } from 'gatsby-plugin-image';

export const SSection = styled.section`
  background-color: transparent;
`;

export const SPostSection = styled.section`
  display: flex;
  margin-bottom: 15px;
`;

export const SPostDetails = styled.section`
  margin-left: 15px;
  padding: 5px 0;
  flex: 1;
`;

export const SPostTitle = styled.h5`
  color: ${props => props.theme.colors.main};
`;

export const SPostDate = styled.section`
  font-size: 14px;
  color: ${props => props.theme.colors.dark_grey};
`;

export const SSectionTitle = styled.h5`
  margin-bottom: 25px;
`;

export const SPostImage = styled(GatsbyImage)`
  width: 80px;
  border-radius: 5px;
`;
